import styled from 'styled-components';
import { Link as link } from 'react-router-dom';

type TextProps = {
  bold?: boolean;
  muted?: boolean;
};

type LinkProps = {
  align?: string;
};

export const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.title};
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.title};
  letter-spacing: -0.3px;
  line-height: 1.3;
`;

export const SubTitle = styled.h2`
  font-family: ${(props) => props.theme.fonts.title};
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.title};
  line-height: 1.4;
`;

export const SectionTitle = styled.h3`
  font-family: ${(props) => props.theme.fonts.title};
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.8px;
`;

export const Text = styled.p<TextProps>`
  font-family: ${(props) => props.theme.fonts.text};
  font-size: 14px;
  line-height: 1.6;
  color: ${(props) =>
    props.muted ? props.theme.colors.textMuted : props.theme.colors.text};
  font-weight: ${(props) => (props.bold ? '600' : '400')};
`;

export const Link = styled(link)<LinkProps>`
  color: ${(props) => props.theme.colors.primary};
  text-align: ${(props) => props.align || 'left'};
  text-decoration: none;
  font-weight: 500;
  transition: color ${(props) => props.theme.transitions.fast};

  &:hover {
    color: ${(props) => props.theme.colors.primaryHover};
    text-decoration: underline;
  }
`;
